module.exports = __webpack_public_path__ + "img/icon_logo.38b01728.png";